import { render, staticRenderFns } from "./AdminFilters.vue?vue&type=template&id=8c1edb98"
import script from "./AdminFilters.vue?vue&type=script&lang=js"
export * from "./AdminFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports